import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Button from './Button';
import WhatsApp from '../services/WhatsApp';
import LanguageSelector from './LanguageSelector';
import { useI18n } from '../i18n/LanguageProvider';
import { contactInfo } from '../data/contactInfo';

const Header = () => {
  const { t, code } = useI18n();
  const wa = WhatsApp.link(contactInfo.phone);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const menuRef = useRef(null);
  const indicatorRef = useRef(null);
  const prevRef = useRef({ left: 0, width: 0 });

  // animate indicator: expand to cover old+new, then shrink to new
  useEffect(() => {
    const menu = menuRef.current;
    const ind = indicatorRef.current;
    if (!menu || !ind) return;

    const active = menu.querySelector('a.active');
    if (!active) {
      ind.style.width = '0px';
      ind.style.left = '0px';
      prevRef.current = { left:0, width:0 };
      return;
    }
    const mb = menu.getBoundingClientRect();
    const b = active.getBoundingClientRect();
    const left = b.left - mb.left;
    const width = b.width;

    const prev = prevRef.current;

    // Phase 0: start at previous without transition
    ind.style.transition = 'none';
    ind.style.left = `${prev.left}px`;
    ind.style.width = `${prev.width}px`;

    const expandLeft = Math.min(prev.left, left);
    const expandRight = Math.max(prev.left + prev.width, left + width);
    const expandWidth = Math.max(4, expandRight - expandLeft);

    // Phase 1: expand quickly (тянется к новой вкладке)
    requestAnimationFrame(() => {
      ind.style.transition = 'left .22s ease-out, width .22s ease-out';
      ind.style.left = `${expandLeft}px`;
      ind.style.width = `${expandWidth}px`;

      // Phase 2: shrink to final (мягко подтягивает второй край)
      setTimeout(() => {
        ind.style.transition = 'left .38s cubic-bezier(.2,.7,0,1), width .38s cubic-bezier(.2,.7,0,1)';
        ind.style.left = `${left}px`;
        ind.style.width = `${width}px`;
      }, 20);
    });

    prevRef.current = { left, width };
  }, [pathname, code]);

  // close mobile panel on route change
  useEffect(() => { setOpen(false); }, [pathname]);

  const navItem = (to, label) => (
    <NavLink to={to} end className={({isActive}) => isActive ? 'active' : undefined}>
      {label}
    </NavLink>
  );

  return (
    <>
      <header className="header">
        <div className="container nav">
          <Link className="brand" to="/">
            <img src="/assets/logo.png" alt="Sparklean logo" />
            <span>Sparklean.care.plus</span>
          </Link>
          <div className="nav-right">
            <LanguageSelector />

            {/* Desktop */}
            <nav ref={menuRef} className="menu" aria-label="Primary">
              {navItem('/', t('header.home'))}
              {navItem('/services', t('header.services'))}
              {navItem('/contact', t('header.contact'))}
              <Link to="/booking"><Button size="sm" variant="primary">{t('header.book')}</Button></Link>
              <a href={wa} target="_blank" rel="noreferrer" aria-label="WhatsApp">
                <Button size="sm" variant="ghost">{t('header.whatsapp')}</Button>
              </a>
              <span id="tab-indicator" ref={indicatorRef} aria-hidden="true" />
            </nav>

            {/* Mobile */}
            <button className="hamburger" aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen(v=>!v)}>
              ☰
            </button>
          </div>
        </div>

        {/* refined mobile panel — всегда покрывает экран под шапкой и анимированно появляется/исчезает */}
        <div id="mobile-menu" className={`mobile-panel ${open ? 'open' : ''}`}>
          <div className="inner" role="menu" aria-label="Mobile navigation">
            <NavLink role="menuitem" to="/" className={({isActive}) => `link ${isActive ? 'active': ''}`}>{t('header.home')} <span>›</span></NavLink>
            <NavLink role="menuitem" to="/services" className={({isActive}) => `link ${isActive ? 'active': ''}`}>{t('header.services')} <span>›</span></NavLink>
            <NavLink role="menuitem" to="/contact" className={({isActive}) => `link ${isActive ? 'active': ''}`}>{t('header.contact')} <span>›</span></NavLink>
            <Link role="menuitem" className="link" to="/booking">{t('header.book')} <span>›</span></Link>
            <a role="menuitem" className="link" href={wa} target="_blank" rel="noreferrer">{t('header.whatsapp')} <span>›</span></a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
